/** 转盘奖池 pool_type（string），与后端对齐后可改 */
export const RAFFLE_POOL_TYPE = 'gift_treasure_hunt_world_cup'

export const LOTTERY_RECORD_PAGE_SIZE = 20

/** 首次进入主活动页规则半屏标记 */
export const WORLD_CUP_RULE_INIT_KEY = 'luck_gift_world_cup_rule_init'

export const TURNTABLE_SLOT_COUNT = 9

export const MAX_TICKET_DISPLAY = 9999
